import React, { useCallback, useEffect } from 'react';
import CRM from '../Inputs/CRM';
import File from '../Inputs/File';

export const FOREIGN_OPTION_CODE = 'Sim';

export default function EffectsCursos({
    validStatus,
    inputs,
    isBrazilian,
    setIsBrazilian,
    uf,
    crmValue,
    AddDataField,
    handleCrmChange,
    handleCrmBlur,
    handleUfChange,
    confirmOption,
    confirmInput,
    uploadFile,
    text,
    brazilianStates,
    registerData,
    setRegisterData,
    emailResponse
}) {
    const brasileiro = inputs?.find(input => input.slug === 'brasileiro');

    const crm = inputs?.find(input => input.slug === 'crm');
    const attachDocument = inputs?.find(input => input.slug === 'attach-a-document-medical-degree');

    // Set default foreign option when brasileiro field exists but CRM is shown
    useEffect(() => {
        if (brasileiro && crm) {
            AddDataField(brasileiro, FOREIGN_OPTION_CODE);
        }
    }, [brasileiro, crm]);

    const handleForeignChange = useCallback((value) => {
        AddDataField(brasileiro, value);
        setIsBrazilian(value == FOREIGN_OPTION_CODE);
        console.log(value == FOREIGN_OPTION_CODE);
        
    }, [brasileiro, setIsBrazilian]);

    const handleBlur = useCallback((event, isRequired) => {
        if (isRequired) {
            confirmOption(event.target);
        }
    }, [confirmOption]);

    const renderRequiredIndicator = (isRequired) => (
        isRequired ? <span>*</span> : null
    );

    const renderRadioOption = useCallback((option, isChecked, input) => (
        <div className="options_item" key={option?.codigo}>
            <input
                type="radio"
                checked={isChecked}
                id={input.slug + option}
                name={input.nome}
                value={option}
                className="option"
                onChange={e => handleForeignChange(e.target.value)}
                onBlur={e => handleBlur(e, input.obrigatorio)}
            />
            <label htmlFor={input.slug + option}>{option}</label>
        </div>
    ), [handleForeignChange, handleBlur]);

    const renderForeignField = useCallback(() => {
        if (!brasileiro) return null;

        return (
            <label className="fullsize" key={brasileiro.slug}>
                <p>
                    {brasileiro.nome} {renderRequiredIndicator(brasileiro.obrigatorio)}
                </p>
                <div className="options_group">
                    {renderRadioOption('Sim', isBrazilian, brasileiro)}
                    {renderRadioOption('Não', !isBrazilian, brasileiro)}
                </div>
            </label>
        );
    }, [brasileiro, isBrazilian, renderRadioOption]);
    const renderCrmField = useCallback(() => {
        if (!crm) return null;

        return (
            <>
                {   
                    emailResponse === 2 ? (
                        <>
                            <label className="midsize" htmlFor="name"><p>{text.nome} <span>*</span></p> 
                                <input 
                                    name={text.nome} 
                                    placeholder={text.nome}
                                    type="text" 
                                    onChange={e => setRegisterData({...registerData, name:e.target.value})} 
                                    onBlur={e => confirmInput(e.target)} 
                                    value={registerData.name || ''}
                                    required
                                    />
                            </label>
                            <label className="midsize" htmlFor="surname"><p>{text.sobrenome} <span>*</span></p> 
                                <input 
                                    name={text.sobrenome}
                                    placeholder={text.sobrenome}
                                    type="text" 
                                    onChange={e => setRegisterData({...registerData, surname:e.target.value})}
                                    onBlur={e => confirmInput(e.target)} 
                                    value={registerData.surname || ''}
                                    required
                                    />
                            </label>
                        </>
                    ) : null
                }
                <label className="fullsize" key={crm.slug}>
                    <p>
                        {crm.nome} {renderRequiredIndicator(crm.obrigatorio)}
                    </p>
                    <div className="ValidateCRM">
                        <CRM
                            input={crm}
                            AddDataField={handleCrmChange}
                            confirmInput={confirmInput}
                            crmValue={crmValue}
                            validate={handleCrmBlur}
                        />
                        <select
                            name="uf"
                            id="uf"
                            onChange={e => handleUfChange(crm, e.target.value)}
                            value={uf}
                            required={crm.obrigatorio}
                        >
                            <option value="" disabled>{text.crmEstado}</option>
                            {brazilianStates.map(state => (
                                <option key={state.codigo} value={state.codigo}>
                                    {state.valor}
                                </option>
                            ))}
                        </select>
                    </div>
                </label>
            </>
        );
    }, [brazilianStates, confirmInput, crm, crmValue, handleCrmBlur, handleCrmChange, handleUfChange, text.crmEstado, uf]);

    const renderAttachmentField = useCallback(() => {
        if (!attachDocument) return null;

        return (
            <label className="midsize" key={attachDocument.slug}>
                <p>
                    {attachDocument.nome} {renderRequiredIndicator(attachDocument.obrigatorio)}
                </p>
                <File
                    input={attachDocument}
                    uploadFile={uploadFile}
                    confirmInput={confirmInput}
                />
            </label>
        );
    }, [attachDocument, confirmInput, uploadFile]);

    if (!validStatus) return null;

    return (
        <>
            {renderForeignField()}
            {!isBrazilian ? renderAttachmentField() : renderCrmField()}
        </>
    );
}